module.exports = __webpack_public_path__ + "img/phone-rotary.9574861b.svg";